import { LabelLangString } from "component/LabelLang/label-lang";
// import { SOCIAL_MEDIA_APP_ID } from "configs/AppConfig";
// import React from "react";
import { useSelector } from "react-redux";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookIcon,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";
export const FacebookShare = ({ url, tags = [], children, title }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const renderTags = () => {
    if (tags.length == 0) return "";
    let tagsListToString = "";
    tags.forEach((tag) => {
      const tagName = LabelLangString({
        id: "tagName",
        currentLocale: currentLocale,
        defaultValue: tag.tagName,
        translations: tags.tagTranslation,
      }).replaceAll(" ", "_");
      tagsListToString += `#${tagName}`;
    });

    return tagsListToString;
  };
  return (
    <FacebookShareButton url={url} quote={title} hashtag={renderTags()}>
      {children}
    </FacebookShareButton>
  );
};

export const TwitterShare = ({ url, tags = [], children, title }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  const renderTags = () => {
    if (tags.length == 0) return [];
    let tagsListToString = [];
    tags.forEach((tag) => {
      const tagName = LabelLangString({
        id: "tagName",
        currentLocale: currentLocale,
        defaultValue: tag.tagName,
        translations: tags.tagTranslation,
      }).replaceAll(" ", "_");
      tagsListToString.push(tagName);
    });
    return tagsListToString;
  };
  return (
    <TwitterShareButton
      url={url}
      title={title}
      quote={"Title or jo bhi aapko likhna ho"}
      hashtags={renderTags()}
    >
      {children}
    </TwitterShareButton>
  );
};
export const LinkedinShare = ({ url, brief, children, title }) => {
  return (
    <LinkedinShareButton url={url} source={url} title={title} summary={brief}>
      {children}
    </LinkedinShareButton>
  );
};
